export default __webpack_public_path__ + "static/world-d4127926a192a8b21ccd86eec035f963.jpg";